import type { BadgeTone } from '@/components/ui/Badge'
import type { OrganizationRole, OrganizationType } from '@/types/auth'

/** Danske betegnelser for organisationsroller. Skal matche backendens `RoleLabels`. */
export const ROLE_LABELS: Record<OrganizationRole, string> = {
  Owner: 'Ejer',
  Administrator: 'Administrator',
  Member: 'Medlem',
  BillingAdministrator: 'Fakturaansvarlig',
  ReadOnly: 'Læseadgang',
}

/** Hvad rollen giver adgang til. Vises som hjælpetekst i rollevælgeren. */
export const ROLE_DESCRIPTIONS: Record<OrganizationRole, string> = {
  Owner: 'Fuld adgang, inklusive at slette organisationen og udnævne andre ejere.',
  Administrator: 'Kan administrere projekter, medlemmer og indstillinger.',
  Member: 'Får adgang gennem de projekter, vedkommende tilføjes til.',
  BillingAdministrator: 'Kun adgang til abonnement og fakturering.',
  ReadOnly: 'Kan kun læse. Egnet til revisorer og bygherrer.',
}

export const ROLE_TONES: Record<OrganizationRole, BadgeTone> = {
  Owner: 'brand',
  Administrator: 'info',
  Member: 'neutral',
  BillingAdministrator: 'warning',
  ReadOnly: 'neutral',
}

/** Roller der kan vælges i UI'et, i faldende rækkefølge efter adgang. */
export const ASSIGNABLE_ROLES: OrganizationRole[] = [
  'Owner',
  'Administrator',
  'Member',
  'BillingAdministrator',
  'ReadOnly',
]

export const ORGANIZATION_TYPE_LABELS: Record<OrganizationType, string> = {
  Unspecified: 'Ikke angivet',
  Contractor: 'Entreprenør',
  Architect: 'Arkitekt',
  Engineering: 'Ingeniør',
  ClientOrDeveloper: 'Bygherre eller udvikler',
  Municipality: 'Kommune',
  HousingAssociation: 'Boligforening',
  PropertyManagement: 'Ejendomsadministration',
  Consultant: 'Rådgiver',
}

export const ORGANIZATION_TYPES = Object.keys(ORGANIZATION_TYPE_LABELS) as OrganizationType[]

export const INVITATION_STATUS_LABELS: Record<string, string> = {
  Pending: 'Afventer',
  Accepted: 'Accepteret',
  Expired: 'Udløbet',
  Revoked: 'Tilbagekaldt',
}
